import QuestionBank from '../components/QuestionBank';
import Pageheader from '../utils/headerHelment';

const QuestionBankView = () => {
    return (
        <>
            <Pageheader title="LENS - Question Bank" />
            <QuestionBank />
        </>
    );
};

export default QuestionBankView;
